import {DateOnly} from "./DateOnly";
import {DateTime} from "./DateTime";
import {TimeOnly} from "./TimeOnly";

const _dateRegExp: RegExp = /^\d{4}-\d{2}-\d{2}/;
const _timeRegExp: RegExp = /^\d{2}:\d{2}:\d{2}/;
const _dateTimeRegExp: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

function reviver(this: any, key: string, value: any, context: { source: string } | null): any {
	if (value == null) {
		return null;
	}

	const typeOf = typeof (value);
	if (context != null && typeOf === "number" && value.toString() != context.source) {
		//si el nº parseado no coincide con el nº como texto, devuelvo el texto (por ejemplo, con longs)
		return context.source;
	}

	//opt: si la longitud del string es mayor a 30, no parseo ya que seguro no es una fecha.
	if (typeOf === "string" && value.length <= 30) {
		if (_dateTimeRegExp.test(value)) {
			return DateTime.fromIsoString(value);
		}

		if (_dateRegExp.test(value)) {
			return DateOnly.fromIsoString(value);
		}

		if (_timeRegExp.test(value)) {
			return TimeOnly.fromIsoString(value);
		}

		return value;
	}

	return value;
}

export default function decodeJson<T>(data: string): T | undefined {
	if (data == null || data.length === 0) {
		return undefined;
	}

	// @ts-ignore
	return JSON.parse(data, reviver);
}
